import { useState, useEffect } from 'react';
import { useFeatureToggle } from '@css-xp/base';
import { STATSIG_FEATURE_GATES } from '@css-xp/ppc-constants';
import { usePartnerDomainContext, PartnerDomainContextProviderState } from '@css-xp/ppc-user-context';

export const usePartnerAccountDomains = (partnerAccount: any) => {
  const [domainsInfo, setDomainsInfo] = useState<PartnerDomainContextProviderState>({
    data: null,
    isLoading: false,
    error: null,
  });

  const domainsInfoViaContext = usePartnerDomainContext();

  const [isEnabled] = useFeatureToggle();
  const isSFDCDataCachingEnabledForPartnerProfile = isEnabled(
    STATSIG_FEATURE_GATES.ENABLE_SFDC_DATA_CACHING_FOR_PARTNER_PROFILE
  );

  useEffect(() => {
    if (partnerAccount?.id) {
      if (isSFDCDataCachingEnabledForPartnerProfile) {
        setDomainsInfo(domainsInfoViaContext);
      } else {
        setDomainsInfo({
          data: {
            id: partnerAccount?.id,
            domain: partnerAccount?.domain,
            alternateDomains: partnerAccount?.alternateDomains,
            relatedDomains: partnerAccount?.relatedDomains,
          },
          isLoading: false,
          error: null,
        });
      }
    }
  }, [partnerAccount, isSFDCDataCachingEnabledForPartnerProfile, domainsInfoViaContext]);

  return domainsInfo;
};
